<div class="section">
    <div data-qa-id="locums-rec-board-certifications-header" class="nova__label">Board Certification/s</div>
    <div data-qa-id="locums-rec-board-certifications-value">
        <label *ngIf="boardCertifications?.length === 0" data-qa-id="locums-rec-board-certifications-dash">-</label>
        <div class="jd__section__container" *ngIf="boardCertifications?.length > 0">
            <ng-container *ngFor=" let boardCertification of boardCertifications; let i=index">
                <label [attr.data-qa-id]="'locums-rec-board-certifications-label-' + i">
                    {{ boardCertification.name }}
                </label>
                <label class="jd__section__emphasized" [attr.data-qa-id]="'locums-rec-board-certifications-details-' + i">
                    {{ locumsUtility.getBoardCertificationDetails(boardCertification) }}
                </label>
            </ng-container>
        </div>
    </div>
</div>

